import React from 'react';
import Grid from '@mui/material/Grid';
import TextCyrillic from '../components/TextCyrillic';
import TextLatin from '../components/TextLatin';
import { latinize } from '../util/latinize';

function Converter({ cyrillicText, latinText, onChange }) {
  const handleCyrillicChange = (cyrillic) => {
    onChange(cyrillic, latinize(cyrillic));
  }

  return <Grid container spacing={2}>
    <Grid item xs={12} md={6}>
      <TextCyrillic value={cyrillicText} onChange={handleCyrillicChange} />
    </Grid>
    <Grid item xs={12} md={6}>
      <TextLatin value={latinText} />
    </Grid>
  </Grid>
}

Converter.defaultProps = {
  cyrillicText: "",
  latinText: "",
  onChange: () => { }
}

export default Converter;
